import { sanitizeFormHtml } from "./html-sanitizer";
var HTML_RENDER_AREAS = new Set(["designer-tab", "preview-tab"]);
var HTML_SCHEMA_PROPERTIES = new Set([
    "html",
    "completedHtml",
    "completedBeforeHtml",
    "loadingHtml",
]);
var configuredSurveys = new WeakSet();
var attachHtmlSanitizer = function (survey) {
    if (configuredSurveys.has(survey))
        return;
    survey.onProcessHtml.add(function (_, options) {
        options.html = sanitizeFormHtml(options.html);
    });
    configuredSurveys.add(survey);
};
export var configureCreatorHtmlSanitization = function (creator) {
    attachHtmlSanitizer(creator.survey);
    var attachToRenderInstance = function (_, options) {
        if (HTML_RENDER_AREAS.has(options.area)) {
            attachHtmlSanitizer(options.survey);
        }
    };
    var creatorWithSetupHandlers = creator;
    if (creatorWithSetupHandlers.onSurveyInstanceSetupHandlers) {
        creatorWithSetupHandlers.onSurveyInstanceSetupHandlers.add(attachToRenderInstance);
        return;
    }
    creator.onSurveyInstanceCreated.add(attachToRenderInstance);
};
var sanitizeHtmlPropertyValue = function (value) {
    if (typeof value === "string") {
        return sanitizeFormHtml(value);
    }
    if (Array.isArray(value)) {
        return value.map(sanitizeHtmlPropertyValue);
    }
    if (value !== null && typeof value === "object") {
        return Object.fromEntries(Object.entries(value).map(function (_a) {
            var key = _a[0], childValue = _a[1];
            return [
                key,
                sanitizeHtmlPropertyValue(childValue),
            ];
        }));
    }
    return value;
};
var sanitizeSchemaNode = function (value) {
    if (Array.isArray(value)) {
        return value.map(sanitizeSchemaNode);
    }
    if (value !== null && typeof value === "object") {
        return Object.fromEntries(Object.entries(value).map(function (_a) {
            var key = _a[0], childValue = _a[1];
            return [
                key,
                HTML_SCHEMA_PROPERTIES.has(key)
                    ? sanitizeHtmlPropertyValue(childValue)
                    : sanitizeSchemaNode(childValue),
            ];
        }));
    }
    return value;
};
export var sanitizeSurveySchemaHtml = function (schema) {
    return sanitizeSchemaNode(schema);
};
